import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const OpsContext = createContext();

export const useOpsContext = () => {
  const context = useContext(OpsContext);
  if (!context) {
    throw new Error('useOpsContext must be used within OpsContextProvider');
  }
  return context;
};

export const OpsContextProvider = ({ children }) => {
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const [organizations, setOrganizations] = useState([]);

  // Initialize with default organization if available
  useEffect(() => {
    if (adminOrgs && adminOrgs.length > 0 && !selectedOrganization) {
      setSelectedOrganization(adminOrgs[0].id);
    }
  }, [adminOrgs, selectedOrganization]);

  const clearSelection = () => {
    setSelectedPractitioner(null);
  };

  const value = {
    selectedOrganization,
    setSelectedOrganization,
    selectedPractitioner,
    setSelectedPractitioner,
    organizations,
    setOrganizations,
    clearSelection,
  };

  return <OpsContext.Provider value={value}>{children}</OpsContext.Provider>;
};
